import React from 'react';
import { RoleSkeleton, TextSkeleton } from './Loaders.styles';
import { Hidden, IconButton } from '@material-ui/core';
import { union } from 'lodash';
import { IoClose } from 'react-icons/io5';
import { LuShare2 } from 'react-icons/lu';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';
import ProjectDetails from '../ProjectItem/ProjectDetails/ProjectDetails';
import {
  ProjectItemCont,
  MainInfo,
  CompanyText,
  ProjectText,
  UnionsText,
  Labels,
  LabelsCont,
  DatesLocationInfo,
  RateInfo,
  ButtonCont,
  ButtonsCont,
  ActionButton,
  ProjectRoleCont,
  HiddenRoles,
  ProjectHeader,
} from '../ProjectItem/ProjectItem.styles';
import { Skeleton } from '@material-ui/lab';

const ProjectLoaders = () => {
  return (
    <ProjectItemCont>
      <ProjectHeader>
        <MainInfo>
          <Skeleton variant="text" />
          <Skeleton variant="text" />
          <Skeleton variant="text" />

          <Hidden mdUp>
            <Skeleton variant="text" />
          </Hidden>
        </MainInfo>
        <Hidden smDown>
          <LabelsCont>
            <TextSkeleton />
            <TextSkeleton />
            <TextSkeleton />
          </LabelsCont>
          <DatesLocationInfo>
            <TextSkeleton />
            <TextSkeleton />
            <TextSkeleton />
          </DatesLocationInfo>
          <LabelsCont rate={1}>
            <TextSkeleton />
          </LabelsCont>
          <RateInfo>
            <TextSkeleton />
          </RateInfo>
        </Hidden>

        <Hidden smDown>
          <ButtonCont>
            <Skeleton variant="rect" width={40} height={40} />
            <ButtonsCont>
              <Skeleton variant="rect" width={80} />
              <Skeleton variant="rect" width={80} />
            </ButtonsCont>
          </ButtonCont>
        </Hidden>
        {/* mobile view */}
        <Hidden mdUp>
          <ButtonCont>
            <ButtonsCont>
              <Skeleton variant="rect" width={80} />
              <Skeleton variant="rect" width={80} />
            </ButtonsCont>
            <Skeleton variant="rect" width={'100%'} />
          </ButtonCont>
        </Hidden>
      </ProjectHeader>
      {/* View More Mobile extra header */}
      <Hidden mdUp>
        <ProjectHeader>
          <LabelsCont rate={1}>
            <TextSkeleton />
            <TextSkeleton />
            <TextSkeleton />
          </LabelsCont>
          <DatesLocationInfo>
            <TextSkeleton />
            <TextSkeleton />
            <TextSkeleton />
          </DatesLocationInfo>
          <LabelsCont rate={1}>
            <TextSkeleton />
          </LabelsCont>
        </ProjectHeader>
      </Hidden>

      <ProjectRoleCont>
        <RoleSkeleton variant="rect" />
        {/* <RoleSkeleton variant="rect" /> */}
      </ProjectRoleCont>

      <Skeleton variant="rect" height={30} width={230} style={{ marginLeft: 15, marginBottom: 15 }} />
    </ProjectItemCont>
  );
};

export default ProjectLoaders;
